module.exports = __webpack_public_path__ + "product/quote-b117d9eaf57edf2b3b0f6cd8b8599a79.svg";